import API from "../config/api.js";

export const ProjectService = {
  getProjectRegionClubs(id, search) {
    return API.get(`api/service-project/${id}/region-clubs/se=${search}`);
  },

  createProjectInfo(data) {
    return API.post(`api/service-project/info/save`, data);
  },

  createProjectClubContribution(data) {
    return API.post(`api/service-project/clubs-contribution/save`, data);
  },

  getProjectClubContribution(id) {
    return API.get(`api/service-project/${id}/clubs-contribution/list`);
  },

  createGovernorThemes(data) {
    return API.post(`api/service-project/district-governor-theme/save`, data);
  },

  getGovernorThemeList(id) {
    return API.get(`api/service-project/${id}/district-governor-theme/list`);
  },

  deleteProjectGovernorTheme(id) {
    return API.delete(
      `api/service-project/DISTRICT_GOVERNOR_THEME/${id}/delete`
    );
  },

  deleteProjectCommittee(id) {
    return API.delete(`api/service-project/PROJECT_COMMITTEE/${id}/delete`);
  },

  deleteProjectClubContribution(id) {
    return API.delete(`api/service-project/CLUBS_CONTRIBUTION/${id}/delete`);
  },

  dropMember(uuid) {
    return API.post(`api/project/delete/${uuid}`);
  },

  deleteProjectParticipant(id) {
    return API.delete(`api/service-project/PROJECT_PARTICIPANT/${id}/delete`);
  },

  projectUpdate(uuid, data) {
    return API.post(`api/project/update/${uuid}`, data);
  },

  updateInfo(id, data) {
    return API.post(`api/service-project/${id}/update-info`, data);
  },

  getParticipantList(id) {
    return API.get(`api/service-project/${id}/participant/list`);
  },

  createParticipant(data) {
    return API.post(`api/service-project/participant/save`, data);
  },

  createCommitteeMembers(data) {
    return API.post(`api/service-project/committee-member/save`, data);
  },

  getCommitteeMemberList(id) {
    return API.get(`api/service-project/${id}/committee-member/list`);
  },

  documentUpload(id, data) {
    return API.post(`api/project/${id}/upload-documents`, data);
  },

  getProjectInfo(uuid) {
    return API.get(`api/project/info/${uuid}`);
  },

  getProjectList(search, status, page=1) {
    const queryParams = [];
    queryParams.push(`se=${encodeURIComponent(search)}`);
    if (status) {
      queryParams.push(`status=${encodeURIComponent(status)}`);
    }
    const queryString = queryParams.length ? `${queryParams.join('&')}?page=${page}` : '';
    return API.get(`api/projects/list/${queryString}`);
  },

  checkCanApproval(id) {
    return API.get(`api/service-project/${id}/approve-user`);
  },

  updateApproval(id, data) {
    return API.post(`api/service-project/${id}/approve-update`, data);
  },

  statusPending(id, data) { 
    return API.post(`api/service-project/${id}/pending`, data);
  },

  delete(id) { 
    return API.delete(`api/service-project/${id}/delete`);
  },

  updateContribution(id, data) { 
    return API.post(`api/service-project-contribution/${id}/update`, data);
  },

  updatePointsStatus(data) { 
    return API.post(`api/project-points/update-status`, data);
  },

  refreshPoints(uuid) { 
    return API.post(`api/service-project/${uuid}/point-calculate`);
  },


  downloadReports(type, month,  header) { 
    return API.get(`api/service-project/${month}/reports/${type}`, header);
  },

  getCustomersList() {
    return API.get(`api/customers/list`);
  },

  getUsersList() {
    return API.get(`api/user/list`);
  },

  createProject(data) { 
    return API.post(`api/project/create`, data);
  },
  
  createTask(id,data) {
    return API.post(`api/projectTask/create/${id}`, data);
  },

  downloadDocuments(id){
    return API.get(`api/project/download-documents/${id}`, { responseType: "blob" });
  },

  deleteDocument(id,data){
    return API.post(`api/project/${id}/delete-documents`, data);
  },

  addProjectMembers(id,data){
    return API.post(`api/project/${id}/add-members`, data);
  },

  addProjectComments(id,data){
    return API.post(`api/project/${id}/add-comments`, data);
  },

  deleteProjectComments(id,data){
    return API.post(`api/project/${id}/delete-comments`, data);
  },

  deleteProjectMembers(id,data){
    return API.post(`api/project/${id}/delete-members`, data);
  },

  sendProjectUuid(uuid){
    return API.get(`api/xero/create-invoice/${uuid}`);
  },

  getProjectsOverview(filter){
    return API.get(`api/project/statics/${filter}`);
  },
  getRecentProjects(){
    return API.get(`api/project/recent-projects`);
  },
  getProjectTaskStatics(uuid){
    return API.get(`api/project/${uuid}/statics`);
  },
  updateProjectStatus(id,data){
    return API.post(`api/project/${id}/update-status`, data);
  },
  updateProjectPriority(id,data){
    return API.post(`api/project/${id}/update-priority`, data);
  },

  getProjectCustomerInfo(project_code){
    return API.get(`api/project/${project_code}/project-customer`);
  },
  getChartData(){
    return API.get(`api/project/overview-statics`);
  },

  addDynamicProjectFields(data){
    return API.post(`api/project/addDynamicProjectFields`, data);
  },

  getDynamicProjectFields(){
    return API.get(`api/project/getDynamicFields`);
  },

  getProjectTypes(){
    return API.get(`api/project/project-type`);
  },

  getProjectBranches(){
    return API.get(`api/project/project-branch`);
  },

  getProjectTaskList(uuid, search, status, stage, category, member, page=1) {
    const queryParams = [];
  
    queryParams.push(`se=${encodeURIComponent(search)}`);
  
    if (status) {
      queryParams.push(`status=${encodeURIComponent(status)}`);
    }
  
    if (stage) {
      queryParams.push(`stage=${encodeURIComponent(stage)}`);
    }
  
    if (category) {
      queryParams.push(`category=${encodeURIComponent(category)}`);
    }
  
    if (member) {
      queryParams.push(`member=${encodeURIComponent(member)}`);
    }

    const queryString = queryParams.length ? `${queryParams.join('&')}?page=${page}` : '';
  
    return API.get(`api/project/${uuid}/task-list/${queryString}`);
  },
  getUserProjectNameList(search, page=1){
    return API.get(`api/project/user-project-name-list/se=${search}?page=${page}`);
  },
  
};
